import React from 'react';
import { H2, P, UL, LI, FeatureLink } from './_shared';

export default {
  slug: 'branding',
  title: 'Brokerage branding',
  category: 'account',
  summary: 'Logo, colors, custom domain, and signature blocks that appear on every doc and client-facing email.',
  searchTerms: ['branding', 'logo', 'colors', 'domain', 'white label', 'brokerage'],
  related: ['team-workspace'],
  Body: () => (
    <>
      <P>
        Brokerage-tier plans (Agency and Enterprise) get branding controls
        that propagate to every client-facing surface — signing UI, doc
        headers, email templates, and the client portal.
      </P>

      <H2>What you can customize</H2>
      <UL>
        <LI><strong>Logo</strong> — shown in the top-left of the signing UI and on document headers.</LI>
        <LI><strong>Colors</strong> — primary, accent, link. Pick from a brand palette or paste hex codes.</LI>
        <LI><strong>Email-from name</strong> — appears as the sender on automated emails to your clients.</LI>
        <LI><strong>Custom domain</strong> — point sign.yourbrokerage.com at our load balancer (TLS auto-provisioned).</LI>
        <LI><strong>Signature block</strong> — agent name, license, brokerage, phone, license disclosure — rendered at the bottom of every doc.</LI>
      </UL>

      <H2>Setting it up</H2>
      <P>
        <FeatureLink to="/settings/branding">Settings → Branding</FeatureLink>.
        Most fields preview live; the custom-domain step is a one-time DNS
        change with instructions in the UI.
      </P>
    </>
  ),
};
